import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import { QRCodeCanvas } from 'qrcode.react';
import HeaderOfPage from "../tools/headerOfPage";

type LanguageCode = string;

interface MultilingualField {
    [key: string]: string;
}

interface ProductColor {
    name: string;
    hex: string;
    stock: boolean;
}

interface ProductData {
    name: MultilingualField;
    url: MultilingualField;
    keywords: MultilingualField;
    description: MultilingualField;
    parent: string | null;
    code: string;
    sku?: string;
    productCode?: string;
    stock?: number;
    type?: string;
    mainprice: number | null;
    alt?: MultilingualField;
    colors?: ProductColor[];
}

export default function ListPr() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'List Products',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="List Products"></HeaderOfPage>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
                    <div className="lg:col-span-1" dir="rtl">
                        <NewProductForm reloaditem={reloadgame} key={key}></NewProductForm>
                    </div>
                    <div className="lg:col-span-3">
                        <ListofProducts key={key}></ListofProducts>
                    </div>
                </div>
            </div>
        </>
    )
}

function ListofProducts() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [name, setName] = useState<string>('');
    const [group, setGroup] = useState<string>('');
    const [listgroup, setListArticle] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const [languages, setLanguages] = useState<Array<{ code: LanguageCode; label: string }>>([]);

    // Helper function to get display name from multilingual or string
    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            // Use the selected language, fallback to others if not available
            return name[activeLang] || name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    // Helper function to render group options with unlimited levels
    const renderGroupOptions = (groups: any[], level: number = 0, isLast: boolean[] = []): JSX.Element[] => {
        if (!groups || !Array.isArray(groups)) return [];
        
        return groups.map((group: any, index: number) => {
            const displayName = getDisplayName(group.name);
            const groupId = group._id || group.id;
            const isLastItem = index === groups.length - 1;
            const currentIsLast = [...isLast, isLastItem];
            
            // Visual indicator for hierarchy levels
            let prefix = '';
            if (level > 0) {
                // Build prefix based on parent levels
                const prefixParts: string[] = [];
                for (let i = 0; i < level - 1; i++) {
                    prefixParts.push(currentIsLast[i] ? '   ' : '│  ');
                }
                prefixParts.push(isLastItem ? '└─ ' : '├─ ');
                prefix = prefixParts.join('');
            }
            
            const children = group.togroup && Array.isArray(group.togroup) && group.togroup.length > 0
                ? renderGroupOptions(group.togroup, level + 1, currentIsLast)
                : [];
            
            return (
                <React.Fragment key={groupId}>
                    <option value={groupId}>
                        {prefix}{displayName}
                    </option>
                    {children}
                </React.Fragment>
            );
        });
    };

    const loaddata = async (page = 1) => {
        setLoading(true);
        try {
            let res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/pproducts?page=${page}&name=${name}&group=${group}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data.message;
            setList(mydata);
            setCurrentPage(page);
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading products'),
            });
        } finally {
            setLoading(false);
        }
    }

    const getalldata = async () => {
        try {
            // Get all groups without filtering
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup/getall',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            })

            const allGroups = res.data.message || [];
            
            // Build tree structure from flat list
            const buildTree = (groups: any[], parentId: string | null = null): any[] => {
                return groups
                    .filter((group: any) => {
                        const groupParent = group.subgroup || null;
                        return (parentId === null && (groupParent === null || groupParent === '')) ||
                               (parentId !== null && groupParent === parentId);
                    })
                    .map((group: any) => {
                        const children = buildTree(groups, group._id || group.id);
                        return {
                            ...group,
                            togroup: children.length > 0 ? children : undefined
                        };
                    })
                    .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0));
            };

            const treeGroups = buildTree(allGroups);
            setListArticle(treeGroups);
        } catch (error: any) {
            console.error('Error loading groups:', error);
        }
    }

    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Product!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('Yes, delete it'),
            cancelButtonText: t('Cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/pproducts/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted'),
                        text: t('Product deleted successfully'),
                        timer: 1500,
                        showConfirmButton: false
                    });

                    loaddata(currentPage);
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: error.response?.data?.message || t('Error deleting product'),
                    });
                }
            }
        });
    }

    // Load languages for ListofProducts
    const loadLanguagesForList = async (): Promise<Array<{ code: LanguageCode; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data.message || [];
            const mappedLanguages = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0))
                .map((lang: any) => ({
                    code: lang.code as LanguageCode,
                    label: lang.label
                }));
            setLanguages(mappedLanguages);
            if (mappedLanguages.length > 0) {
                setActiveLang(mappedLanguages[0].code);
            }
            return mappedLanguages;
        } catch (error) {
            console.error('Error loading languages:', error);
            const fallbackLanguages = [
                { code: 'ku' as LanguageCode, label: 'Kurdish' },
                { code: 'fa' as LanguageCode, label: 'فارسی' },
                { code: 'en' as LanguageCode, label: 'English' },
                { code: 'ar' as LanguageCode, label: 'العربية' },
                { code: 'tr' as LanguageCode, label: 'Türkçe' }
            ];
            setLanguages(fallbackLanguages);
            return fallbackLanguages;
        }
    };

    useEffect(() => {
        const initialize = async () => {
            await loadLanguagesForList();
            await Promise.all([loaddata(1), getalldata()]);
        };
        initialize();
    }, []);

    if (loading && !list) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-8">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
                <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
            </div>
        );
    }

    return (
        <div className="space-y-4" dir="rtl">
            {/* Filters Card */}
            <div className="bg-white rounded-xl shadow-sm p-6">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-gray-800">فیلتر و جستجو</h3>
                    {/* Language Selector */}
                    <div className="flex items-center gap-3">
                        <span className="text-sm font-medium text-gray-700">زبان نمایش:</span>
                        <div className="flex gap-2 flex-wrap">
                            {languages.map((lang) => (
                                <button
                                    key={lang.code}
                                    type="button"
                                    onClick={() => setActiveLang(lang.code)}
                                    className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                        activeLang === lang.code
                                            ? 'bg-blue-600 text-white'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                                >
                                    {lang.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            نام محصول
                        </label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                            placeholder="جستجو بر اساس نام..."
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            گروه
                        </label>
                        <select
                            value={group}
                            onChange={(e) => setGroup(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                        >
                            <option value="">همه گروه‌ها</option>
                            {listgroup != null && Array.isArray(listgroup) && listgroup.length > 0 && renderGroupOptions(listgroup)}
                        </select>
                    </div>
                    <div className="flex items-end">
                        <button
                            onClick={() => loaddata(1)}
                            className="w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                        >
                            اعمال فیلتر
                        </button>
                    </div>
                </div>
            </div>

            {/* Products Table */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Name')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Firstpage')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Action')}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {list && list.docs && list.docs.length > 0 ? (
                                list.docs.map((item: any) => {
                                    const badges = [];
                                    if (item.firstpage == 1) badges.push({ text: 'صفحه اول', color: 'bg-purple-100 text-purple-800' });
                                    if (item.special == 1) badges.push({ text: 'پرفروش', color: 'bg-green-100 text-green-800' });
                                    if (item.special1 == 1) badges.push({ text: 'جدیدترین', color: 'bg-blue-100 text-blue-800' });
                                    if (item.special2 == 1) badges.push({ text: 'ویژه', color: 'bg-yellow-100 text-yellow-800' });

                                    return (
                                        <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-6 py-4">
                                                <div className="flex items-start">
                                                    <div className="flex-1">
                                                        <div className="text-sm font-medium text-gray-900">
                                                            {getDisplayName(item.name)}
                                                        </div>
                                                        {item.toGroup && (
                                                            <div className="text-sm text-gray-500 mt-1">
                                                                <span className="inline-flex items-center gap-1">
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                                                    </svg>
                                                                    گروه: {getDisplayName(item.toGroup.name)}
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="text-xs text-yellow-600 mt-1 font-mono">
                                                            {getDisplayName(item.url)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex flex-wrap items-center justify-center gap-2">
                                                    {badges.length > 0 ? (
                                                        badges.map((badge, idx) => (
                                                            <span
                                                                key={idx}
                                                                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badge.color}`}
                                                            >
                                                                {badge.text}
                                                            </span>
                                                        ))
                                                    ) : (
                                                        <span className="text-gray-400 text-sm">-</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center gap-2">
                                                   
                                                    <a
                                                        href={`/dashboard/Products/Products/${item.id}`}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition-colors"
                                                        title="ویرایش"
                                                    >
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                    </a>
                                                    <button
                                                        onClick={() => deleted(item.id)}
                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                                                        title="حذف"
                                                    >
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={3} className="px-6 py-12 text-center">
                                        <div className="flex flex-col items-center">
                                            <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                            </svg>
                                            <p className="text-gray-500 text-lg">محصولی یافت نشد</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {list && list.totalPages > 1 && (() => {
                    const currentPage = list.page;
                    const totalPages = list.totalPages;
                    const maxPagesToShow = 10;
                    
                    // Function to generate page numbers to display
                    const getPageNumbers = (): (number | string)[] => {
                        if (totalPages <= maxPagesToShow) {
                            // Show all pages if total is less than or equal to max
                            return Array.from({ length: totalPages }, (_, i) => i + 1);
                        }
                        
                        const pages: (number | string)[] = [];
                        const sidePages = Math.floor((maxPagesToShow - 3) / 2); // Pages on each side of current
                        
                        // Always show first page
                        pages.push(1);
                        
                        let startPage = Math.max(2, currentPage - sidePages);
                        let endPage = Math.min(totalPages - 1, currentPage + sidePages);
                        
                        // Adjust if we're near the start
                        if (currentPage <= sidePages + 1) {
                            endPage = Math.min(totalPages - 1, maxPagesToShow - 1);
                        }
                        
                        // Adjust if we're near the end
                        if (currentPage >= totalPages - sidePages) {
                            startPage = Math.max(2, totalPages - (maxPagesToShow - 2));
                        }
                        
                        // Add ellipsis after first page if needed
                        if (startPage > 2) {
                            pages.push('ellipsis-start');
                        }
                        
                        // Add pages around current
                        for (let i = startPage; i <= endPage; i++) {
                            pages.push(i);
                        }
                        
                        // Add ellipsis before last page if needed
                        if (endPage < totalPages - 1) {
                            pages.push('ellipsis-end');
                        }
                        
                        // Always show last page
                        if (totalPages > 1) {
                            pages.push(totalPages);
                        }
                        
                        return pages;
                    };
                    
                    const pageNumbers = getPageNumbers();
                    
                    return (
                        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                            <div className="flex items-center justify-between">
                                <div className="text-sm text-gray-700">
                                    نمایش {((list.page - 1) * list.limit) + 1} تا {Math.min(list.page * list.limit, list.totalDocs)} از {list.totalDocs} محصول
                                </div>
                                <nav className="flex items-center gap-2">
                                    {list.prevPage && (
                                        <button
                                            onClick={() => loaddata(list.page - 1)}
                                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                        >
                                            قبلی
                                        </button>
                                    )}
                                    {pageNumbers.map((pageNum, index) => {
                                        if (pageNum === 'ellipsis-start' || pageNum === 'ellipsis-end') {
                                            return (
                                                <span key={`ellipsis-${index}`} className="px-2 text-gray-500">
                                                    ...
                                                </span>
                                            );
                                        }
                                        return (
                                            <button
                                                key={pageNum}
                                                onClick={() => loaddata(pageNum as number)}
                                                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                                                    list.page === pageNum
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                                                }`}
                                            >
                                                {pageNum}
                                            </button>
                                        );
                                    })}
                                    {list.nextPage && (
                                        <button
                                            onClick={() => loaddata(list.page + 1)}
                                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                        >
                                            بعدی
                                        </button>
                                    )}
                                </nav>
                            </div>
                        </div>
                    );
                })()}
            </div>
        </div>
    )
}

function NewProductForm({ reloaditem }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    // Default colors for clothes products
    const defaultColors: ProductColor[] = [
        { name: 'Black', hex: '#000000', stock: false },
        { name: 'White', hex: '#FFFFFF', stock: false },
        { name: 'Red', hex: '#FF0000', stock: false },
        { name: 'Blue', hex: '#0000FF', stock: false },
        { name: 'Green', hex: '#008000', stock: false },
        { name: 'Yellow', hex: '#FFFF00', stock: false },
        { name: 'Orange', hex: '#FFA500', stock: false },
        { name: 'Purple', hex: '#800080', stock: false },
        { name: 'Pink', hex: '#FFC0CB', stock: false },
        { name: 'Gray', hex: '#808080', stock: false },
        { name: 'Brown', hex: '#A52A2A', stock: false },
        { name: 'Navy', hex: '#000080', stock: false },
    ];

    const [data, setData] = useState<ProductData>({
        name: {},
        url: {},
        keywords: {},
        description: {},
        parent: null,
        code: '',
        sku: '',
        productCode: '',
        stock: 0,
        type: 'retail',
        mainprice: null,
        colors: []
    });
    const [list, setListArticle] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState(1);
    const [saving, setSaving] = useState(false);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const [languages, setLanguages] = useState<Array<{ code: LanguageCode; label: string }>>([]);

    // Load languages
    const loadLanguages = async (): Promise<Array<{ code: LanguageCode; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data.message || [];
            const mappedLanguages = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0))
                .map((lang: any) => ({
                    code: lang.code as LanguageCode,
                    label: lang.label
                }));
            setLanguages(mappedLanguages);
            if (mappedLanguages.length > 0) {
                setActiveLang(mappedLanguages[0].code);
            }
            return mappedLanguages;
        } catch (error) {
            console.error('Error loading languages:', error);
            const fallbackLanguages = [
                { code: 'ku' as LanguageCode, label: 'Kurdish' },
                { code: 'fa' as LanguageCode, label: 'فارسی' },
                { code: 'en' as LanguageCode, label: 'English' },
                { code: 'ar' as LanguageCode, label: 'العربية' },
                { code: 'tr' as LanguageCode, label: 'Türkçe' }
            ];
            setLanguages(fallbackLanguages);
            return fallbackLanguages;
        }
    };

    // Helper function to initialize multilingual field
    const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
        if (!field) {
            const obj: MultilingualField = {};
            languageCodes.forEach(code => obj[code] = '');
            return obj;
        }
        if (typeof field === 'string') {
            const obj: MultilingualField = {};
            languageCodes.forEach(code => obj[code] = field);
            return obj;
        }
        if (typeof field === 'object') {
            const obj: MultilingualField = { ...field };
            languageCodes.forEach(code => {
                if (!obj[code]) obj[code] = '';
            });
            return obj;
        }
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    };

    // Helper function to safely access multilingual fields
    const getMultilingualValue = (field: MultilingualField, lang: LanguageCode): string => {
        return field[lang] || '';
    };

    // Helper function to get display name from multilingual or string
    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    // Helper function to render group options with unlimited levels
    const renderGroupOptions = (groups: any[], level: number = 0, isLast: boolean[] = []): JSX.Element[] => {
        if (!groups || !Array.isArray(groups)) return [];
        
        return groups.map((group: any, index: number) => {
            const displayName = getDisplayName(group.name);
            const groupId = group._id || group.id;
            const isLastItem = index === groups.length - 1;
            const currentIsLast = [...isLast, isLastItem];
            
            // Visual indicator for hierarchy levels
            let prefix = '';
            if (level > 0) {
                // Build prefix based on parent levels
                const prefixParts: string[] = [];
                for (let i = 0; i < level - 1; i++) {
                    prefixParts.push(currentIsLast[i] ? '   ' : '│  ');
                }
                prefixParts.push(isLastItem ? '└─ ' : '├─ ');
                prefix = prefixParts.join('');
            }
            
            const children = group.togroup && Array.isArray(group.togroup) && group.togroup.length > 0
                ? renderGroupOptions(group.togroup, level + 1, currentIsLast)
                : [];
            
            return (
                <React.Fragment key={groupId}>
                    <option value={groupId}>
                        {prefix}{displayName}
                    </option>
                    {children}
                </React.Fragment>
            );
        });
    };

    const setName = (name: string) => {
        const updatedName = {
            ...data.name,
            [activeLang]: name
        };

        const updatedUrl = { ...data.url };
        updatedUrl[activeLang] = String(changeUrl(name)); // Slug generated for active language

        setData((prev: ProductData) => ({
            ...prev,
            url: updatedUrl,
            name: updatedName
        }));
    }

    const save = async () => {
        setError(null);
        setSaving(true);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/pproducts',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Product added successfully'),
                timer: 1500,
                showConfirmButton: false
            });

            // Reset form with current languages
            const languageCodes = languages.length > 0 
                ? languages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            const emptyMultilingualField: MultilingualField = {};
            languageCodes.forEach(code => emptyMultilingualField[code] = '');
            setData({
                name: { ...emptyMultilingualField },
                url: { ...emptyMultilingualField },
                keywords: { ...emptyMultilingualField },
                description: { ...emptyMultilingualField },
                parent: null,
                code: '',
                sku: '',
                productCode: '',
                stock: 0,
                mainprice: null,
                colors: []
            });

            reloaditem();
            let x = key + 1;
            setKey(x);
        } catch (error: any) {
            // Safely extract error message - handle both string and object errors
            let errorMessage = 'خطا در ذخیره محصول';
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object') {
                    // Handle Mongoose validation errors or other error objects
                    if (msg.message) {
                        errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                    } else if (msg._message) {
                        errorMessage = typeof msg._message === 'string' ? msg._message : String(msg._message);
                    } else {
                        errorMessage = JSON.stringify(msg);
                    }
                } else {
                    errorMessage = String(msg);
                }
            }
            setError(errorMessage);
            
            if (error.response?.data?.code != null) {
                Swal.fire({
                    icon: 'error',
                    title: t('Error'),
                    text: `"${getMultilingualValue(data.url, activeLang)}" slug is available.`,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('Error'),
                    text: errorMessage,
                });
            }
        } finally {
            setSaving(false);
        }
    }

    const getalldata = async () => {
        try {
            // Get all groups without filtering
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup/getall',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            })

            const allGroups = res.data.message || [];
            
            // Build tree structure from flat list
            const buildTree = (groups: any[], parentId: string | null = null): any[] => {
                return groups
                    .filter((group: any) => {
                        const groupParent = group.subgroup || null;
                        return (parentId === null && (groupParent === null || groupParent === '')) ||
                               (parentId !== null && groupParent === parentId);
                    })
                    .map((group: any) => {
                        const children = buildTree(groups, group._id || group.id);
                        return {
                            ...group,
                            togroup: children.length > 0 ? children : undefined
                        };
                    })
                    .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0));
            };

            const treeGroups = buildTree(allGroups);
            setListArticle(treeGroups);
        } catch (error) {
            console.error('Error loading groups:', error);
        }
    }

    useEffect(() => {
        const initialize = async () => {
            await loadLanguages();
            await getalldata();
        };
        initialize();
    }, []);

    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";

    return (
        <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">{t('محصول جدید')}</h3>
            
            {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-800">{error}</p>
                </div>
            )}

            <form key={key} className="space-y-4">
                {/* Language Selector */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        زبان / Language
                    </label>
                    <div className="flex gap-2 flex-wrap">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        نام ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.name, activeLang)}
                        className={inputstyle}
                        placeholder="نام محصول را وارد کنید"
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        URL ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.url, activeLang)}
                        className={inputstyle}
                        placeholder="slug"
                        onChange={(e) => setData(prev => ({
                            ...prev,
                            url: {
                                ...prev.url,
                                [activeLang]: e.target.value
                            }
                        }))}
                        required
                    />
                    <p className="mt-1 text-xs text-gray-500">به صورت خودکار از نام تولید می‌شود</p>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        قیمت پایه
                    </label>
                    <input
                        dir="ltr"
                        type="number"
                        value={data.mainprice || ''}
                        className={inputstyle}
                        placeholder="000"
                        onChange={(e) => setData(prev => ({ ...prev, mainprice: e.target.value ? parseFloat(e.target.value) : null }))}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        کد
                    </label>
                    <input
                        type="text"
                        value={data.code}
                        className={inputstyle}
                        placeholder="کد محصول"
                        onChange={(e) => setData(prev => ({ ...prev, code: e.target.value }))}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        SKU
                    </label>
                    <input
                        type="text"
                        dir="ltr"
                        value={data.sku || ''}
                        className={inputstyle + " text-left"}
                        placeholder="SKU"
                        onChange={(e) => setData(prev => ({ ...prev, sku: e.target.value }))}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        کد محصول / Product Code
                    </label>
                    <input
                        type="text"
                        dir="ltr"
                        value={data.productCode || ''}
                        className={inputstyle + " text-left"}
                        placeholder="Product Code"
                        onChange={(e) => setData(prev => ({ ...prev, productCode: e.target.value }))}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        موجودی / Stock
                    </label>
                    <input
                        dir="ltr"
                        type="number"
                        value={data.stock || 0}
                        className={inputstyle}
                        placeholder="0"
                        min="0"
                        onChange={(e) => setData(prev => ({ ...prev, stock: e.target.value ? parseInt(e.target.value) : 0 }))}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        نوع / Type
                    </label>
                    <select
                        value={data.type || 'retail'}
                        onChange={(e) => setData(prev => ({ ...prev, type: e.target.value }))}
                        className={inputstyle}
                    >
                        <option value="retail">خرده فروشی / Retail</option>
                        <option value="wholesale">عمده فروشی / Wholesale</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Group')}
                    </label>
                    <select
                        value={data.parent || ''}
                        onChange={(e) => setData(prev => ({ ...prev, parent: e.target.value || null }))}
                        className={inputstyle}
                    >
                        <option value="">{t('Choice Group')} ...</option>
                        {list != null && Array.isArray(list) && list.length > 0 && renderGroupOptions(list)}
                    </select>
                </div>

                {/* Color Selection */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        رنگ‌های محصول / Product Colors
                    </label>
                    <div className="space-y-3">
                        {/* Default Colors Palette */}
                        <div>
                            <p className="text-xs text-gray-500 mb-2">رنگ‌های پیش‌فرض:</p>
                            <div className="flex flex-wrap gap-2">
                                {defaultColors.map((color) => {
                                    const isSelected = data.colors?.some(c => c.hex === color.hex);
                                    return (
                                        <button
                                            key={color.hex}
                                            type="button"
                                            onClick={() => {
                                                const currentColors = data.colors || [];
                                                if (isSelected) {
                                                    // Remove color if already selected
                                                    setData(prev => ({
                                                        ...prev,
                                                        colors: currentColors.filter(c => c.hex !== color.hex)
                                                    }));
                                                } else {
                                                    // Add color with default stock: false
                                                    setData(prev => ({
                                                        ...prev,
                                                        colors: [...currentColors, { ...color, stock: false }]
                                                    }));
                                                }
                                            }}
                                            className={`relative w-10 h-10 rounded-lg border-2 transition-all ${
                                                isSelected 
                                                    ? 'border-blue-600 ring-2 ring-blue-300' 
                                                    : 'border-gray-300 hover:border-gray-400'
                                            }`}
                                            style={{ backgroundColor: color.hex }}
                                            title={color.name}
                                        >
                                            {isSelected && (
                                                <div className="absolute inset-0 flex items-center justify-center">
                                                    <svg className="w-5 h-5 text-white drop-shadow-lg" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                    </svg>
                                                </div>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Selected Colors with Stock Toggle */}
                        {data.colors && data.colors.length > 0 && (
                            <div className="mt-4 space-y-2">
                                <p className="text-xs text-gray-500 mb-2">رنگ‌های انتخاب شده:</p>
                                <div className="space-y-2 max-h-48 overflow-y-auto">
                                    {data.colors.map((color, index) => (
                                        <div key={index} className="flex items-center gap-3 p-2 bg-gray-50 rounded-lg">
                                            <div
                                                className="w-8 h-8 rounded border border-gray-300 flex-shrink-0"
                                                style={{ backgroundColor: color.hex }}
                                                title={color.name}
                                            />
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm font-medium text-gray-700 truncate">{color.name}</p>
                                                <p className="text-xs text-gray-500">{color.hex}</p>
                                            </div>
                                            <label className="flex items-center gap-2 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={color.stock}
                                                    onChange={(e) => {
                                                        const updatedColors = [...(data.colors || [])];
                                                        updatedColors[index] = { ...color, stock: e.target.checked };
                                                        setData(prev => ({
                                                            ...prev,
                                                            colors: updatedColors
                                                        }));
                                                    }}
                                                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                />
                                                <span className="text-sm text-gray-700">موجود</span>
                                            </label>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const updatedColors = (data.colors || []).filter((_, i) => i !== index);
                                                    setData(prev => ({
                                                        ...prev,
                                                        colors: updatedColors
                                                    }));
                                                }}
                                                className="text-red-600 hover:text-red-800 p-1"
                                                title="حذف رنگ"
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.keywords, activeLang)}
                        rows={3}
                        className={inputstyle}
                        placeholder="کلمات کلیدی (با کاما جدا کنید)"
                        onChange={(e) => setData(prev => ({ 
                            ...prev, 
                            keywords: { 
                                ...prev.keywords, 
                                [activeLang]: e.target.value 
                            } 
                        }))}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        rows={4}
                        className={inputstyle}
                        placeholder="توضیحات محصول"
                        onChange={(e) => setData(prev => ({ 
                            ...prev, 
                            description: { 
                                ...prev.description, 
                                [activeLang]: e.target.value 
                            } 
                        }))}
                    />
                </div>

                <button
                    type="button"
                    onClick={save}
                    disabled={saving || !getMultilingualValue(data.name, activeLang) || !getMultilingualValue(data.url, activeLang)}
                    className="w-full py-3 px-4 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                >
                    {saving ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            در حال ذخیره...
                        </>
                    ) : (
                        <>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            {t('Save')}
                        </>
                    )}
                </button>
            </form>
        </div>
    )
}
